import {
  initializePdfFormStateObject,
  pdfFormReducerActions,
} from "../../submission/RequestSubmissionReducer";
import { statusColor } from "../../submission/upload/DocumentUpload";
import { UPLOAD_STATUS } from "../../submission/upload/DocumentUpload";

export const init = (payload) => {
  const {
    isSupplement,
    request,
    attachments,
    additionalDocs,
    supplements,
    supplementDocs,
    letters,
    uploadConstraints,
  } = payload;

  let pdfForm = initializePdfFormStateObject(
    request.pdfFormUrl,
    request.pdfFormName,
    request.fieldDefinitions,
    1.5
  );

  delete request.fieldDefinitions;

  attachments.forEach((attachment) => {
    if (attachment.supplementRequired) {
      attachment["supplement"] = {
        uploadStatus: UPLOAD_STATUS.NOT_STARTED,
        uploadError: null,
        uploadProgress: 0,
        label: attachment.label,
        link: "",
        file: null,
        href: "/pdf/ePosta.pdf",
        required: false,
      };
    }
  });

  additionalDocs.forEach((additionalDoc) => {
    additionalDoc["supplement"] = {
      uploadStatus: UPLOAD_STATUS.NOT_STARTED,
      uploadError: null,
      uploadProgress: 0,
      label: additionalDoc.label,
      link: "",
      file: null,
      href: "/pdf/ePosta.pdf",
      required: false,
    };
  });

  letters.forEach((letter) => {
    if (letter.supplementRequired) {
      letter["supplement"] = {
        uploadStatus: UPLOAD_STATUS.NOT_STARTED,
        uploadError: null,
        uploadProgress: 0,
        label: letter.label,
        link: "",
        file: null,
        href: "/pdf/ePosta.pdf",
        required: false,
      };
    }
  });

  supplements.forEach((supplement) => {
    if (supplement.supplementRequired) {
      supplement["supplement"] = {
        uploadStatus: UPLOAD_STATUS.NOT_STARTED,
        uploadError: null,
        uploadProgress: 0,
        label: supplement.label,
        link: "",
        file: null,
        href: "/pdf/ePosta.pdf",
        required: false,
      };
    }
  });

  return {
    isSupplement,
    pdfForm,
    request: { ...request },
    attachments: [...attachments],
    additionalDocs: [...additionalDocs],
    supplements: [...supplements],
    supplementDocs: [...supplementDocs],
    letters: [...letters],
    uploadConstraints: { ...uploadConstraints },
  };
};

export const reducer = (state, action) => {
  switch (action.type) {
    case "init":
      return init(action.payload);
    case "reset":
      state.pdfForm.validationErrors = {};
      state.pdfForm.currentFieldValues = { ...state.pdfForm.previous };
      return { ...state, pdfForm: { ...state.pdfForm } };
    case "save-previous-field-values":
      return {
        ...state,
        pdfForm: {
          ...state.pdfForm,
          previous: { ...state.pdfForm.currentFieldValues },
        },
      };
    case "update-documents":
      state.attachments
        .concat(state.additionalDocs)
        .filter((doc) => doc.supplementRequired)
        .forEach((doc) => {
          doc.color = statusColor(doc.supplement.uploadStatus);
        });
      return { ...state };
    default:
      return pdfFormReducerActions(state, action) || state;
  }
};
